"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const React = __importStar(require("react"));
const OperationalContext_1 = require("../OperationalContext/OperationalContext");
const utils_1 = require("../utils");
const useListbox_1 = require("../useListbox");
const Popout_1 = __importDefault(require("./Popout"));
const SidenavItem_styled_1 = require("./SidenavItem.styled");
const Tooltip_1 = __importDefault(require("../Tooltip/Tooltip"));
const SidenavItem = (_a) => {
    var { to, active, icon: Icon, label, compact, compactLabel, end, className, items, onClick, dark } = _a, props = __rest(_a, ["to", "active", "icon", "label", "compact", "compactLabel", "end", "className", "items", "onClick", "dark"]);
    const isActive = Boolean(active);
    const [isLabelVisible, setIsLabelVisible] = React.useState(false);
    const { isOpen, setIsOpen, buttonProps, getChildProps } = useListbox_1.useListbox({ itemCount: items ? items.length : 0 });
    const ctx = OperationalContext_1.useOperationalContext();
    React.useEffect(() => {
        if (items && setIsOpen) {
            const handleClickOnBodyWhenWeHaveItems = () => {
                setIsOpen(false);
            };
            document.addEventListener("click", handleClickOnBodyWhenWeHaveItems);
            return () => document.removeEventListener("click", handleClickOnBodyWhenWeHaveItems);
        }
    }, [items]);
    const handleClickOnSidenavItem = React.useCallback(e => {
        e.stopPropagation();
        if (onClick) {
            onClick(e);
        }
        if (!utils_1.isModifiedEvent(e) && ctx.pushState && to && !utils_1.isOutsideLink(to)) {
            e.preventDefault();
            ctx.pushState(to);
        }
    }, [onClick, to]);
    const handleClickOnNestedItem = React.useCallback(item => (e) => {
        e.preventDefault();
        if (item.onClick) {
            item.onClick(item);
        }
    }, []);
    const handleKeyDownOnNestedItem = React.useCallback(item => (e) => {
        if (!item.onClick) {
            return;
        }
        e.preventDefault();
        e.stopPropagation();
        switch (e.key) {
            case " ":
                item.onClick(item);
                return;
        }
    }, []);
    return (React.createElement(SidenavItem_styled_1.StyledSidenavItem, Object.assign({ tabIndex: to ? 0 : -1 }, buttonProps, props, { isDark: Boolean(dark), hasIcon: Boolean(Icon), hasItems: Boolean(items), compact: Boolean(compact), as: Boolean(to) ? "a" : "div", className: `${className || ""}${end ? " operational-ui__sidenav-item_end" : ""}`, onMouseEnter: () => (Boolean(items) ? setIsOpen && setIsOpen(true) : setIsLabelVisible(true)), onMouseLeave: () => (Boolean(items) ? setIsOpen && setIsOpen(false) : setIsLabelVisible(false)), hasOnClick: Boolean(onClick), isActive: isActive, onClick: handleClickOnSidenavItem }, to && { href: to }),
        Icon && (React.createElement(SidenavItem_styled_1.IconContainer, { compact: Boolean(compact) },
            React.createElement(Icon, { size: compact ? 24 : 18 }))),
        label && (compact ? isLabelVisible && React.createElement(Tooltip_1.default, null, compactLabel || label) : label),
        !compact && items && React.createElement(SidenavItem_styled_1.Caret, { isOpen: isOpen || false }),
        items && isOpen && (React.createElement(Popout_1.default, { "data-cy": "operational-ui__SidenavItemPopover" }, items.map((item, index) => (React.createElement(SidenavItem, Object.assign({ items: item.items, icon: item.icon, key: index, label: item.label, onClick: handleClickOnNestedItem(item), onKeyDown: handleKeyDownOnNestedItem(item), dark: dark }, getChildProps && getChildProps(index)))))))));
};
exports.default = SidenavItem;
//# sourceMappingURL=SidenavItem.js.map